// extracted by mini-css-extract-plugin
export default {"app-market-page":"_13ymbmh","appMarketPage":"_13ymbmh","app-market-page-background-color":"_gs6bc","appMarketPageBackgroundColor":"_gs6bc","appPage":"_1krokb9"};